import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import UploadForm from "./UploadForm";

const Upload = () => {



  return (
    <>
      <Header icon={"fa-solid fa-users fa-xl mx-2"}  label={"Admin/Upload"}/>
      <main id="main" className="main">
        <section className="section ">
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <div className='card'>

                <div className='card-body'>
                  <UploadForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
export default Upload;
